import React from "react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Renders a QR code image fetched from the backend `/api/partners/qr` endpoint.
 * Props:
 *  - value: URL or text to encode
 *  - size: pixel size of the box (default 6 = ~150px image)
 *  - label: optional caption below
 *  - className: wrapper classes
 */
export default function QRCode({ value, size = 6, label, className = "" }) {
  if (!value) return null;
  const url = `${API}/api/partners/qr?data=${encodeURIComponent(value)}&size=${size}`;
  return (
    <div className={`inline-flex flex-col items-center gap-2 ${className}`} data-testid={`qrcode-${(value || "").slice(0, 24)}`}>
      <img src={url} alt={label || "QR Code"} className="rounded-lg bg-[#F7F6F2] p-2 shadow-md" />
      {label && <div className="text-[10px] uppercase tracking-wider text-white/55 text-center max-w-[160px]">{label}</div>}
    </div>
  );
}
